import loadable from '@loadable/component'

export const TmsIndexAsync = loadable(() => {
  return import(
    /* webpackChunkName: "tms" */
    /* webpackPrefetch: true */
    './index'
  )
})

export default TmsIndexAsync
